import { Button } from '@mybridge/ui/button';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { HStack } from '@mybridge/ui/layout';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Text } from '@mybridge/ui/text';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { PostBoxContext } from 'v4/components/post/context';

export const PostBoxRepostModal = ({ ...props }) => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const direction = useDirection();
  const { repostModal, repostPost, repostLoading } = useContext(PostBoxContext);

  return (
    <Modal size="2xl" {...props}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text>{t('post.repost') || "Repost"}</Text>
          <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
        </ModalHeader>
        <ModalBody>
          {t('otherPage.repostConfirmation')|| "Are you sure you want to repost this post on your timeline?"}
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Button
              variant="secondary"
              borderRadius="50px"
              onClick={(e) => repostModal?.onClose?.()}
            >
              {t('buttons.cancel')||"Cancel"}
            </Button>
            <Button
            borderRadius="50px"
              isLoading={repostLoading}
              onClick={(e) => repostPost()}
              variant="primary"
            >
              {t('post.repost') || "Repost"}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
